import base64 from 'base-64'
import sha256 from 'sha256'

const secretKeyGenerator =(params)=>base64.encode(sha256(JSON.stringify(params)))

export default secretKeyGenerator;